const garmentOptions = [
  { label: 'Choose garment', fabricNeeded: '' },
  {
    label: 'Tops/Shirts',
    fabricNeeded:
      '1x shirt length + 1x sleeve length + 10cm seam allowance (optional: + 30cm for facings)',
  },
  {
    label: 'Jackets/Blazer',
    fabricNeeded: '2x jacket length + 1x sleeve length + 10cm seam allowance',
  },
  {
    label: 'Coats',
    fabricNeeded: '2x coat length + 1x sleeve length. Lining: 1,5x coat length',
  },
  {
    label: 'Dresses',
    fabricNeeded:
      '1x dress length + 1x sleeve length + 10cm seam allowance (optional: + 30cm for facings)',
  },
  {
    label: 'Skirts (a-line, straight)',
    fabricNeeded: '1x skirt length + 30cm for waistband & seam allowance)',
  },
  {
    label: 'Skirts (circle, wider hem)',
    fabricNeeded: '2x skirt length + 30cm for waistband & seam allowance)',
  },
  {
    label: 'Trousers',
    fabricNeeded: '1.5x trousers length + 30cm for waistband & seam allowance',
  },
]

export default garmentOptions
